import React from "react";

export default function GetTest({
  questions,
  actualTestFormat, // this data coming from the backend
  testFormat, //define by us
  Component,
  what,
}) {
  return (
    <>
      {actualTestFormat === testFormat && (
        <div className="test-block" style={{ width: "100%" }}>
          <div className="test-body">
            <Component
              what={what}
              question={questions}
              questions={questions}
              index={0}
            />
          </div>
        </div>
      )}
    </>
  );
}
